import { useNavigate } from 'react-router-dom';

import Tasks from 'APP/Tasks';
import { PayloadType } from 'APP/model/message/messageModel.types';
import { RouterLink, RouterState } from 'APP/router/constants';

const MEDIA_TYPES = [PayloadType.Image, PayloadType.Video];

export default ({ message }) => {
  const navigate = useNavigate();
  const media = message.payload.payloads.find((typeObject) =>
    MEDIA_TYPES.includes(typeObject.payload.payloadType)
  );

  const onClick = async () => {
    const link = message.payload.buttonUrl;
    if (!link) {
      return;
    }

    if (Tasks.deeplinks.isDeepLink(link)) {
      Tasks.deeplinks.handleDeepLink(link, navigate);
      return;
    }

    if (Tasks.market.isMarketUrl(link || '')) {
      navigate(RouterLink.Market, {
        state: {
          [RouterState.url]: link,
        },
      });
      return;
    }

    window.open(link, '_blank');
  };
  return { media: media && media.payload, onClick };
};
